import { flameTheme } from '@lightspeed/flame/Core';

import { CONNECTION_STATUS } from '~/renderer/store/connection/types';

import type { ConnectionStatusType } from '~/renderer/store/connection/types';

export const getStatusColor = (status: ConnectionStatusType) => {
  switch (status) {
    case CONNECTION_STATUS.CONNECTED: {
      return flameTheme.colors['green-700'];
    }
    case CONNECTION_STATUS.READY: {
      return flameTheme.colors['orange-500'];
    }
    default:
      return flameTheme.colors['maple-500'];
  }
};
